export const validateFullName = (input: string): boolean => {
  const words = input.trim().split(/\s+/);
  const sanitizedWords = words.map((word) => word.replace(/[^a-zA-Z]/g, ''));
  const filteredWords = sanitizedWords.filter((word) => word.length > 0);
  return filteredWords.length >= 2;
};

export const validatePhone = (input: string): boolean => {
  // Remove all non-digit characters for validation
  const cleanedInput = input.replace(/\D/g, '');
  const numRegex = /^[0-9]{10,15}$/;
  return numRegex.test(cleanedInput);
};

export const validateDateOfBirth = (input: string): boolean => {
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateRegex.test(input)) {
    return false;
  }
  return true;
};
